import statisticService from "../../../services/statistic.service";
import { SET_MESSAGE } from "../message/type";
import { GET_STATISTIC_FAIL, GET_STATISTIC_SUCCESS } from "./type";


  export const statistic = () => (dispatch) => {
    return statisticService.getStatistics().then(
      (response) => {
      
        dispatch({
          type: GET_STATISTIC_SUCCESS,
          payload: response.data
        })
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: response.message,
            status: response.status
          },
        });
        
        return Promise.resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
         
        dispatch({
          type: GET_STATISTIC_FAIL
        })

        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: message,
            status: error.status
          },
        });
  
        return Promise.reject()
      }
    )
  }